import { Map, Record } from "immutable"

import {
    normaliseModel,
    hydrateModel,
    updateChangeModel,
    isMappingSame,
    updateCreateModel,
    mappingToAPI
} from "../model-utils"
import { idify } from "../../reducers/paging/paging-reducer-utils"

export const TopicModel = new Record({
    id: "",
    can_edit: false,
    can_view: true,
    co_curator: "",
    co_curator_status: "",
    description: "",
    dimension_count: 0,
    image_url: "",
    imagePreviewURL: undefined,
    mappings: [],
    media: [],
    momentum: 0,
    name: "",
    owners: [],
    placeholders: [],
    provider: undefined,
    status: "Active",
    type: "",
    viewers: []
})

export function TopicCreateModel() {
    return Map({
        description: "",
        name: "",
        status: "Draft",
        type: "Customised"
    })
}

export const normalisingFields = ["dimensions"]
const addRemoveFields = [
    "dimensions",
    "placeholders",
    "media",
    "owners",
    "viewers",
    {
        name: "mappings",
        comparator: isMappingSame,
        transformAdd: mappings => mappings.map(mappingToAPI),
        transformRemove: idify
    }
]

export const normalise = topic => normaliseModel(topic, ...normalisingFields)
export const hydrate = (topic, ...entityStates) =>
    hydrateModel(topic, normalisingFields, entityStates)

export const updateTopicChangeModel = (
    name,
    value,
    changeModel,
    workingModel
) => updateChangeModel(name, value, changeModel, workingModel, addRemoveFields)

export const updateTopicCreateModel = (
    name,
    value,
    changeModel,
    workingModel
) => updateCreateModel(name, value, changeModel, workingModel, addRemoveFields)
